import React from 'react';
import { StyleSheet, View } from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';
import { Colors } from 'react-native-paper';

import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { AppButton, AppText } from '../form';
import { pixelDimensions } from '../../config/utils';
import { appColors } from '../../assets/styles/global';

const AppHeader = ({
  navigation, title, hasBack, viewStyles, personalNavigate,
}) => {
  const insets = useSafeAreaInsets();
  return (
    <View style={[styles.header, { marginTop: insets.top }, viewStyles]}>
      {hasBack && (
        <AppButton primary disableDefaultColor isCircle style={styles.buttonArrowBack} onPress={personalNavigate ? navigation : () => (navigation.goBack())}>
          <Icon name="chevron-back-circle-outline" style={styles.iconArrowBack} />
        </AppButton>
      )}
      <AppText numberOfLines={1} size="bold" style={styles.textTitle}>{title}</AppText>
    </View>
  );
};

const styles = StyleSheet.create({
  buttonArrowBack: {
    zIndex: 10,
    position: 'absolute',
    left: pixelDimensions(5),
    height: pixelDimensions(10),
    width: pixelDimensions(10),
    justifyContent: 'center',
    alignItems: 'center',
  },
  header: {
    height: pixelDimensions(15),
    paddingVertical: pixelDimensions(2),
    justifyContent: 'center',
    backgroundColor: appColors.primary,
  },
  iconArrowBack: {
    fontSize: pixelDimensions(10),
    color: Colors.white,
  },
  textTitle: {
    width: pixelDimensions(65),
    // textTransform: 'capitalize',
    alignSelf: 'center',
    fontSize: pixelDimensions(5),
    color: Colors.white,
    textAlign: 'center',
    paddingVertical: pixelDimensions(3),
  },
});

export default AppHeader;
